

// var urls = function(){
//   var REBATE_INIT = "ac=init";
// }

// export default {    
//   istest(){
//       console.log("this is test")
//   },
//   init(){
//     return "ac=init";
//   }
// }

var urls = {
  REBATE_INIT: 'rebate/cross_index.php?ct=rebate&ac=init',// 红包初始化
  REBATE_USER: 'rebate/cross_index.php?ct=rebate&ac=user',// 红包用户信息
  REBATE_SHOW: 'rebate/cross_index.php?ct=rebate&ac=show',// 获取红包数据
  REBATE_RECEIVE: 'rebate/cross_index.php?ct=rebate&ac=receive',// 领取红包
  REBATE_RECEIVE_LOG: 'rebate/cross_index.php?ct=rebate&ac=receiveLog',// 红包领取记录
  REBATE_WXAUTH: 'rebate/cross_index.php?ct=rebate&ac=wxAuth',// 微信绑定二维码
  REBATE_EXCHANGELOG: 'rebate/cross_index.php?ct=rebate&ac=exchangeLog',// 兑换日志
  REBATE_EXCHANGE: 'rebate/cross_index.php?ct=rebate&ac=exchangeWx',// 兑换
  REBATE_EDITPASSWORD: 'common/cross_index.php?ct=user&ac=editPassword',// 修改密码
  REBATE_SEND: 'common/cross_index.php?ct=sms&ac=send',// 获取验证码
  REBATE_INFO: 'common/cross_index.php?ct=user&ac=info',// 用户信息接口
  PRODUCT: 'common/cross_index.php?ct=pay&ac=product',// 商品查询接口
  ORDER: 'common/cross_index.php?ct=pay&ac=order',// 商品查询接口
  PAY_DETAIL: 'common/cross_index.php?ct=user&ac=detail',//用户充值信息接口
  
}
// var urls_v2 = {
//   REBATE_INIT: 'rebate/cross_index.php?ct=rebate&ac=init',// 红包初始化
//   REBATE_USER: 'rebate/cross_index.php?ct=rebate&ac=user',// 红包用户信息
//   REBATE_SHOW: 'rebate/cross_index.php?ct=rebate&ac=show',// 获取红包数据
//   REBATE_RECEIVE: 'rebate/cross_index.php?ct=rebate&ac=receive',// 领取红包
//   REBATE_WXAUTH: 'rebate/cross_index.php?ct=rebate&ac=wxAuth',// 微信绑定二维码
//   REBATE_EXCHANGELOG: 'rebate/cross_index.php?ct=rebate&ac=exchangeLog',// 兑换日志
//   REBATE_EXCHANGE: 'rebate/cross_index.php?ct=rebate&ac=exchange',// 兑换
// }
export default urls


// WEBPACK FOOTER //
// ./src/network/urls.js